import React, { useState } from "react";
import { Box, Typography, useTheme, Grid2, Select, MenuItem, TextField } from "@mui/material";
import { useParams } from "react-router-dom";
import HighchartsReact from "highcharts-react-official";
import Highcharts, { color } from "highcharts";
import { fontWeight, letterSpacing, lineHeight, margin, width } from "@mui/system";
import { useGetInvoiceStatusByValueQuery } from "store/slices/apis/paymentTrackerSlice";
import { useGetContractorQuery } from "store/slices/apis/contractors";
import { skipToken } from '@reduxjs/toolkit/query';
import { useGetInvoiceStatusByValueBYArgsQuery } from "store/slices/apis/paymentTrackerSlice";
import { IoIosArrowDown } from "react-icons/io";


const InvoiceStatusByValue = () => {
    const theme = useTheme();
    const { projectId } = useParams();
    const [selectedCategory, setSelectedCategory] = useState(null);

    const { data, isLoading, error } = useGetInvoiceStatusByValueQuery({
        projectId,
    })
    const { data: contractors } = useGetContractorQuery();

    const { data: invoiceData } = useGetInvoiceStatusByValueBYArgsQuery(
        selectedCategory ? { projectId, vendor: selectedCategory } : skipToken
    );

    const categories = contractors?.data?.map(item => item.name) || [];

    const GraphData = selectedCategory ? invoiceData?.data || {} : data?.data || {};




    const invoiceStatusList = [
        { key: "raised", name: "Amount of Invoice Raised", bkcolor: "#415385", data: GraphData?.raised ?? 0 },
        { key: "certified", name: "Amount of Invoice Certified", bkcolor: "#CE412D", data: GraphData?.certified ?? 0 },
        { key: "paid", name: "Amount Paid", bkcolor: "#FDCA41", data: GraphData?.paid ?? 0 },
        { key: "deducted", name: "Amount Deducted", bkcolor: "#006045", data: GraphData?.deducted ?? 0 },
        { key: "hold", name: "Amount on Hold", bkcolor: "#CE412D", data: GraphData?.hold ?? 0 },
    ];





    const chartSeriesData = invoiceStatusList.map((item) => {
        return {
            y: item.data,
            color: item.bkcolor,
            name: item.name,
        };
    });



    const background = invoiceStatusList.map((item) => ({
        y: 100,
        color: "#DDDFE3",

    }));


    const chartOptions = {
        chart: {
            type: "bar",
            height: 350,
            marginBottom: 0,
            spacingTop: 0,
            marginRight: 0,
            marginTop: 30
        },
        title: { text: "" },
        xAxis: {
            categories: invoiceStatusList.map((item) => item.name),
            lineWidth: 0,
            tickLength: 0,
            // offset: 40,
            labels: {
                style: {
                    fontSize: "14px",
                    fontWeight: 500,
                    // lineHeight: "100%",
                    letterSpacing: "-0.4px",
                    color: "#182A4E",
                },
            },
            opposite: false,
        },
        tooltip: {
            formatter: function () {
                return `<b>${this.point.name}</b>: ${this.point.y}`;
            },
            backgroundColor: '#fff',
            borderColor: '#ccc',
            style: {
                color: '#000',
                fontSize: '13px'
            }
        },
        yAxis: {
            title: {
                text: ""
            },
            min: 0,
            tickLength: 5,
            tickWidth: 1,
            tickColor: "#758195",
            gridLineWidth: 0,
            opposite: true,
            lineColor: "#7581954D",
            lineWidth: 1,
            labels: {
                enabled: true,
                style: {
                    fontSize: "12px",
                    color: "#414D55",
                },
                formatter: function () {
                    return this.value;
                },
            },
        },
        legend: { enabled: false },
        plotOptions: {
            series: {
                grouping: false,
                dataLabels: {
                    enabled: true,
                    inside: true,
                    align: "right",
                    x: -10,
                    verticalAlign: "middle",
                    style: {
                        fontSize: "13px",
                        fontWeight: 600,
                        color: "#fff",
                        textOutline: "none",
                    },
                },
            },
        },
        series: [
            {
                name: "BackGround",
                data: background,
                enableMouseTracking: false,
                showInLegend: false,
                dataLabels: {
                    enabled: false
                }

            },
            {
                name: "Invoice Status by Value",
                data: chartSeriesData,
            },
        ],
        credits: { enabled: false },
        responsive: {
            rules: [
                {
                    condition: { maxWidth: 600 },
                    chartOptions: {
                        xAxis: {
                            labels: {
                                style: {
                                    fontSize: "10px", // smaller font for mobile
                                }
                            }
                        },
                        yAxis: {
                            labels: {
                                style: { fontSize: "10px" }
                            }
                        },
                    }
                }
            ]
        }
    };


    return (
        <Box
            sx={{
                padding: 2,
                background: "#fff",
                borderRadius: 2,
                border: '1px solid #2525252E',
                mb: 0,
                height: { xs: "auto", md: "471px" },
                width: "100%",
                minHeight: "100%",
            }}
        >
            <Grid2 container >
                <Grid2 size={{ xs: 12, md: 6 }}>
                    <Typography
                        variant="body"
                        sx={{
                            fontWeight: 500,
                            fontSize: "17px",
                            lineHeight: "100%",
                            letterSpacing: "-0.4px",
                            color: `${theme?.customSettings?.themeColor}`,
                        }}
                    >
                        Invoice Status by Value (in Cr)
                    </Typography>
                </Grid2>
                <Grid2 size={{ xs: 12, md: 6 }} sx={{ mt: { xs: 1.5, md: 0 } }}>
                    <Box sx={{ width: "100%", display: "flex", justifyContent: { xs: 'start', md: 'end' }, }}>
                        <Box sx={{ position: 'relative', width: { xs: '100%', sm: '250px', md: '210px' }, }}>
                            <Select
                                displayEmpty
                                value={selectedCategory || ""}
                                onChange={(e) => setSelectedCategory(e.target.value || null)}
                                IconComponent={IoIosArrowDown}
                                fullWidth
                                sx={{
                                    backgroundColor: '#E8E8E8',
                                    '& .MuiOutlinedInput-input': {
                                        padding: '4px 10px',
                                    },
                                    '& .MuiOutlinedInput-notchedOutline': {
                                        border: 'none',
                                    }
                                }}
                            >

                                <MenuItem value="" disabled>
                                    Consultant/Contractor
                                </MenuItem>


                                {
                                    categories.map((item, index) => (
                                        <MenuItem key={index} value={item}>{item}</MenuItem>
                                    ))
                                }
                            </Select>


                            {selectedCategory && (
                                <Box
                                    onClick={() => setSelectedCategory(null)}
                                    sx={{
                                        position: 'absolute',
                                        right: '35px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        cursor: 'pointer',
                                        fontSize: '18px',
                                        color: '#888',
                                        '&:hover': { color: '#000' },
                                        display: { xs: selectedCategory ? 'block' : 'none', md: 'block' },
                                    }}
                                >
                                    &#10005;
                                </Box>
                            )}
                        </Box>
                    </Box>

                </Grid2>
            </Grid2>
            <Grid2 container sx={{ mt: "45px", }}>
                <Grid2 xs={12} sx={{ width: "100%" }}>
                    <HighchartsReact highcharts={Highcharts} options={chartOptions} />
                </Grid2>
            </Grid2>
        </Box>
    );
};

export default InvoiceStatusByValue;
